var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"mb-3 mt-3"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('p',{staticClass:"text-muted"},[_vm._v(" "+_vm._s(_vm.description)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }